(() => {
  const US_STORE_HOST = 'us.saboskirt.com';
  const COOKIE_NAME = 'openGeClose';
  const COOKIE_VALUE = '1';
  const COOKIE_TTL_MS = 3 * 60 * 60 * 1000; // 3 hours

  function getCookie(name) {
    const match = document.cookie.match(new RegExp(`(?:^|; )${name.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, ttlMs) {
    const d = new Date();
    d.setTime(d.getTime() + ttlMs);
    document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; expires=${d.toUTCString()}; path=/`;
  }

  function isUsStore() {
    return (window.location.hostname || '').toLowerCase() === US_STORE_HOST;
  }

  function buildRedirectUrl() {
    const path = window.location.pathname || '/';
    return `https://${US_STORE_HOST}${path}?utm_source=sabo_us&utm_medium=redirect`;
  }

  function buildRedirectUrlFromCurrentPage(utmMedium) {
    const current = new URL(window.location.href);
    current.protocol = 'https:';
    current.hostname = US_STORE_HOST;
    current.port = '';
    // Preserve existing querystring, but ensure we can attribute the redirect
    current.searchParams.set('utm_source', 'sabo_us');
    current.searchParams.set('utm_medium', utmMedium || 'selector');
    return current.toString();
  }

  function tryCadCurrencySwitch() {
    const params = new URL(window.location.href).searchParams;
    const utm = params.get('utm_medium');
    if (utm !== 'CAD') return false;
    if (isUsStore()) return false;

    // This theme uses Shopify's localization form. Setting country_code=CA will switch to CAD (if enabled).
    const form = document.querySelector('form[action*="/localization"]');
    if (!form) return false;

    const countryInput = form.querySelector('input[name="country_code"]');
    if (!countryInput) return false;

    if (String(countryInput.value || '').toUpperCase() === 'CA') return false;

    countryInput.value = 'CA';
    try {
      form.submit();
      return true;
    } catch {
      return false;
    }
  }

  function ensureStyles() {
    if (document.getElementById('geo-redirect-styles')) return;
    const style = document.createElement('style');
    style.id = 'geo-redirect-styles';
    style.textContent = `
      .geo-redirect-banner {
        border-block-end: 1px solid var(--color-border, rgba(0,0,0,0.1));
      }
      .geo-redirect-banner__inner {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.35em;
        padding: 10px 0;
        font-size: 12px;
        line-height: 1;
        text-align: center;
        white-space: nowrap;
      }
      .geo-redirect-banner__link {
        text-decoration: underline;
        font-weight: 700;
        color: inherit;
      }
      .geo-redirect-overlay {
        position: fixed;
        inset: 0;
        z-index: 2147483647;
        background: rgba(0,0,0,0.8);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 16px;
      }
      .geo-redirect-modal {
        background: #faf9f9;
        color: #332f30;
        width: min(450px, 100%);
        border-radius: 0;
        position: relative;
      }
      .geo-redirect-modal__content {
        padding: 18px 18px 16px;
        text-align: center;
        font-family: sans-serif;
        font-size: 15px;
        font-weight: 300;
        line-height: 1.35;
      }
      .geo-redirect-modal__title {
        display: block;
        margin-bottom: 12px;
        font-size: 18px;
        font-weight: 400;
      }
      .geo-redirect-modal__buttons {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 12px;
        padding: 0 18px 18px;
      }
      .geo-redirect-modal__btn {
        border: 0;
        cursor: pointer;
        padding: 10px 12px;
        font-size: 14px;
        background: #332f30;
        color: #fff;
      }
      .geo-redirect-modal__btn:hover { opacity: 0.85; }
      .geo-redirect-modal__close {
        position: absolute;
        top: 6px;
        right: 10px;
        border: 0;
        background: transparent;
        color: #332f30;
        font-size: 22px;
        line-height: 1;
        cursor: pointer;
      }
      @media screen and (max-width: 480px) {
        .geo-redirect-modal__buttons { grid-template-columns: 1fr; }
      }
    `;
    document.head.appendChild(style);
  }

  function insertBanner(redirectUrl) {
    if (document.getElementById('geo-redirect-banner')) return;
    const container = document.getElementById('announcement-bar') || document.querySelector('.announcement-bar');
    if (!container) return;

    const banner = document.createElement('div');
    banner.id = 'geo-redirect-banner';
    banner.className = 'geo-redirect-banner';
    banner.innerHTML = `
      <div class="page-width">
        <div class="geo-redirect-banner__inner">
          <a class="geo-redirect-banner__link" href="${redirectUrl}">Shop Here</a>
          <span>for USA Orders.</span>
        </div>
      </div>
    `;

    container.insertAdjacentElement('afterbegin', banner);
  }

  function showPopup(countryName, countryHandle, redirectUrl) {
    if (document.getElementById('geo-redirect-overlay')) return;
    if (getCookie(COOKIE_NAME) === COOKIE_VALUE) return;
    if (isUsStore()) return;

    // Avoid annoying merchants in the theme editor preview.
    if (window.Shopify && window.Shopify.designMode) return;

    const flag = String(countryHandle || '').toUpperCase() === 'US' ? '🇺🇸' : '🇨🇦';

    const overlay = document.createElement('div');
    overlay.id = 'geo-redirect-overlay';
    overlay.className = 'geo-redirect-overlay';
    overlay.innerHTML = `
      <div class="geo-redirect-modal" role="dialog" aria-modal="true" aria-label="Store redirect">
        <button type="button" class="geo-redirect-modal__close" aria-label="Close">×</button>
        <div class="geo-redirect-modal__content">
          <span class="geo-redirect-modal__title">Are you shipping to the</span>
          <b><span>${countryName || ''}</span></b> <span aria-hidden="true">${flag}</span>?
        </div>
        <div class="geo-redirect-modal__buttons">
          <button type="button" class="geo-redirect-modal__btn geo-redirect-yes">YES, I am ${flag}</button>
          <button type="button" class="geo-redirect-modal__btn geo-redirect-no">NO, I'm shipping elsewhere</button>
        </div>
      </div>
    `;

    function close() {
      overlay.remove();
      setCookie(COOKIE_NAME, COOKIE_VALUE, COOKIE_TTL_MS);
    }

    overlay.querySelector('.geo-redirect-yes')?.addEventListener('click', () => {
      window.top.location = redirectUrl;
    });
    overlay.querySelector('.geo-redirect-no')?.addEventListener('click', close);
    overlay.querySelector('.geo-redirect-modal__close')?.addEventListener('click', close);
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) close();
    });

    document.body.appendChild(overlay);
  }

  async function run() {
    if (isUsStore()) return;

    // 0) Allow manual redirect via the country/currency selector shortcuts (US/CA rows)
    document.querySelectorAll('[data-us-store-redirect]').forEach((el) => {
      if (el.dataset.usStoreRedirectBound === '1') return;
      el.dataset.usStoreRedirectBound = '1';
      const handler = (e) => {
        e.preventDefault?.();
        e.stopPropagation?.();
        window.top.location = buildRedirectUrlFromCurrentPage('selector');
      };
      el.addEventListener('click', handler);
      el.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') handler(e);
      });
    });

    // 1) CAD param handling (matches prior behavior but using localization form)
    if (tryCadCurrencySwitch()) return;

    // 2) US/CA redirect prompt + announcement banner
    let json = null;
    try {
      const r = await fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' });
      if (r.ok) json = await r.json();
    } catch {
      json = null;
    }

    const handle = json?.detected_values?.country?.handle;
    const name = json?.detected_values?.country?.name;
    if (handle !== 'US' && handle !== 'CA') return;

    ensureStyles();
    const url = buildRedirectUrl();
    insertBanner(url);
    showPopup(name, handle, url);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();


